import {trackOmniClick} from "javascripts/sitebase/es/tracking"

declare global {
  interface Window {
    s_account: string
  }

  const s: any
}

/* Valid values to an Adobe link type for tracking
  o -> Other link - used for internal links or those that do not lead off site
  e -> Exit link - used for links that lead off site
  d -> download link - used for links that start file downloads
 */
type LinkTypeChar = 'o' | 'e' | 'd'
export const LinkType = {
  other: 'o',
  exit: 'e',
  download: 'd'
} as const

export const recordEvent = (events: string, variables: Record<string, string> = {}, eventDescription: string = '', linkType: LinkTypeChar = LinkType.other): void => {
  const defaultVariables = {
    channel: s.channel,
    eVar1: s.channel,
    prop2: s.eVar3 ?? 0,
    eVar3: s.eVar3 ?? 0,
    eVar5: s.pageName,
    eVar13: s.eVar13, // UserId
    prop10: s.eVar13 // UserId
  }

  const mergedVariables = {...defaultVariables, ...variables}

  trackOmniClick(window.s_account, events, mergedVariables, eventDescription, linkType);
}
